<template>
	<div class="login-container">
		<div class="login-box">
			<div class="login-box-wrap">
				<div class="login-title">
					IM聊天系统-登入
				</div>
				<div class="login-item">
					<label>用户名</label>
					<input type="text" v-model="username">
				</div>
				<div class="login-item">
					<label>密码</label>
					<input type="password" v-model="password">
				</div>
				<div class="login-item login-item-remember">
					<input type="checkbox" class="login-remember" v-model="login30">
					<span>勾选后，30天免登录</span>
				</div>
				<div class="login-item">
					<button @click="login">登录</button>
					<button style="background-color: orange;" @click="reset">重置</button>
				</div>
			</div>
			
		</div>
	</div>
</template>

<script>
	import {login} from '../../network/web/login.js'
	export default{
		name:'Login',
		data(){
			return {
				username:'',
				password:'',
				login30:true
			}
		},
		methods:{
			// 重置输入框
			reset(){
				this.username = ''
				this.password = ''
				this.login30 = true
			},
			
			// 登录系统
			login(){
				let _this = this
				login(this.username,this.password,(data)=>{
					layui.use(['layer'],function(){
						let layer = layui.layer
						if(data.code == 1){
							let expireTime = (new Date).getTime() + 24*3600*1000
							if(_this.login30){
								expireTime += 29*24*3600*1000
							}
							let saveLoginInfo = {
								id:data.data.id,
								name:data.data.manager_name,
								expireTime: expireTime
							}
							localStorage.setItem('imLoginInfo',JSON.stringify(saveLoginInfo))
							layer.msg(data.msg,{icon:1,time:2000},function(){
								_this.$store.commit('saveLoginInfo',saveLoginInfo)
								_this.$router.replace('/chat/chat')
							})
						}else{
							layer.msg(data.msg)
						}
					})
				})
			}
		},
		created() {
			localStorage.removeItem('imLoginInfo')
			this.$store.commit('saveLoginInfo',{
				id:0,
				name:''
			})
		}
	}
</script>

<style>
	.login-container{
		width: 100%;
		height: 100%;
		overflow: hidden;
		background-image: url(/img/login-bg.jpg);
		background-size: cover;
		background-position: center;
		background-repeat: no-repeat;
		position: relative;
		z-index: 3;
	}
	.login-container::after{
		content: "";
		width: 100%;
		height: 100%;
		position: absolute;
		left: 0;
		top: 0;
		/* 从父元素继承 background 属性的设置 */
		background: inherit;
		filter: blur(20px);
		z-index: 2;
	}
	.login-box{
		position: absolute;
		width: 400px;
		height: auto;
		left: 50%;
		top: 40%;
		transform: translate(-50%,-40%);
		background-color: #2f2f2f4d;
		box-shadow: 2px 2px 8px 1px #444444;
		z-index: 3;
	}
	.login-box-wrap{
		width: 100%;
		height: 100%;
		padding: 40px;
		box-sizing: border-box;
	}
	.login-title{
		height: 50px;
		line-height: 50px;
		color: #FFFFFF;
		font-size: 16px;
		text-align: center;
	}
	.login-item{
		height: 50px;
		line-height: 50px;
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	.login-item-remember{
		height: 30px !important;
		line-height: 30px !important;
		color: #bfbfbf;
		font-size: 12px;
	}
	.login-item > *{
		display: block;
	}
	.login-item label{
		width: 60px;
		height: 30px;
		line-height: 30px;
		text-align: center;
		color: #FFFFFF;
		background-color: #009688;
	}
	.login-item input{
		flex-grow: 1;
		width: 0;
		height: 30px;
		padding: 0 5px;
		color: #999999;
	}
	.login-item button{
		padding: 3px 14px;
		cursor: pointer;
		background-color: #009688;
		color: #FFFFFF;
		border-radius: 2px;
		margin-right: 10px;
	}
	.login-item .login-remember{
		flex-grow: unset;
		width: 14px;
		height: 14px;
		margin-right: 10px;
	}
</style>
